import { render } from "./AdminInput.vue?vue&type=template&id=24b9a1e9&scoped=true&ts=true"
import script from "./AdminInput.vue?vue&type=script&lang=ts"
export * from "./AdminInput.vue?vue&type=script&lang=ts"

import "./AdminInput.vue?vue&type=style&index=0&id=24b9a1e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b9a1e9"]])

export default __exports__